import {CUSTOM_VAR_DATA_ATTRIBUTE} from '../../../incase-domain/proptypes/runfile';

export function getRunFileVars(): Record<string, unknown> {
    const vars: Record<string, unknown> = {};
    const query = `[${CUSTOM_VAR_DATA_ATTRIBUTE}]`;
    const varNodes = document.querySelector('#canvas-holder')?.querySelectorAll(query);

    varNodes?.forEach((node) => {
        const dataVarValue = node.getAttribute(CUSTOM_VAR_DATA_ATTRIBUTE);

        if (!dataVarValue) return;

        let content;
        if (node.nodeName === 'INPUT' || node.nodeName === 'TEXTAREA') {
            content = (node as HTMLInputElement).value;
        } else {
            content = (node as HTMLElement).textContent?.trim() ?? '';
        }

        if (content) {
            vars[dataVarValue] = content;
        }
    });

    return vars;
}
